import { qualityControlServiceStores } from "@intrasync/quality-control";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Service stores from `@intrasync/quality-control`.
 *
 * Replaces the hand-written `qc.stores.ts`, which declared its own list against
 * the bespoke qc-* API services. Those services are gone (see
 * `services/index.ts` and `20260829000001_retire_bespoke_qc_tables`), so the
 * module's list is now the only description of the QC surface.
 *
 * ServiceStore registration is first-wins/idempotent (see
 * StoreRegistry.registerServiceStore), so a name another module already
 * registers with richer config would shadow this one. Nothing collides today —
 * every name below was checked against `src/serviceStores/` and was free once
 * `qc.stores.ts` was removed.
 *
 * NOTE ON `production-schedule`. The module declares a store for a HOST-owned
 * service at that exact path — singular — and reads `ScheduledQCItem[]` from
 * its `find()` to build the inspector queue. NTX's own scheduling service is
 * `production-schedules` (plural) with a different row shape, so the host
 * supplies a thin adapter at the singular path; see
 * `packages/api/src/services/quality-control/production-schedule/`.
 */
export const qualityControlStores =
  qualityControlServiceStores as unknown as ServiceStoreConfig[];
